import { Descriptions } from 'ant-design-vue'

// 国内运输
export const DomesticTransportationZh = {
  // 中文
  DataStatistics: '数据统计',
  OrderInquiry: '订单查询',
  SubscriptionCenter: '订阅中心',
  SubscribeNow: '我要订阅',
  PastSubscriptions: '历史订阅',
  FeedBack: '没有您想要的，点我反馈！',
  NextStep: '下一步',
  SubscriptTips: '订单创建后，对您进行该节点的邮件通知',
  OrderStatus: '订单状态',
  SubscriptTips2: '选择订阅后，系统会通过邮件的形式发送每周的订单数据',
  RegularReports: '定期报告',
  MonthlySummary: '当月度',
  Last7Days: '近7天',
  LastMonth: '近一个月',
  CustomInput: '自定义输入',
  RouteFiltering: '线路筛选',
  All: '全部',
  TotalOrderVolume: '总单量',
  AwaitingPickup: '待提货',
  PickedUp: '已提货',
  InTransit: '运输中',
  OutforDelivery: '派送中',
  Signedfor: '已签收',
  PickupDelayed: '提货延误',
  DeliveryDelayed: '送货延误',
  PickupOntimeRate: '提货准时率',
  DeliveryOntimeRate: '送货准时率',
  MonthlyMileageStatistics: '月度里程统计',
  MonthlyVehicleTripsCount: '月度车次统计',
  Mileage: '里程数(公里)',
  TotalNumberofTrips: '车次总数(次)',
  echartsTips: '您可以左右拖动柱状图，查看更多线路',
  statement: '免责声明：尊敬的客户，本页面显示的业务相关数据信息，因存在业务量动态变化以及信息更新滞后等情况，仅供参考，无法律约束力。最终信息，以双方书面确认为准，感谢理解与配合。',
  OrderNo: '订单号',
  Placeholder: '请输入',
  OrderPlacementPeriod: '下单区间',
  Query: '查询',
  Reset: '重置',
  Export: '导出',
  DetailsView: '明细查看',
  SerialNo: '序号',
  WaybillNo: '运单号',
  ReferenceFreightCost: '参考运费',
  WaybillStatus: '运单状态',
  TransportationMode: '运输方式',
  OrderDate: '下单日期',
  Product: '产品',
  TotalWeight: '总重量',
  LoadingAddress: '装货地址',
  UnloadingAddress: '卸货地址',
  Actions: '操作',
  Tracking: '轨迹',
  ReceiptProof: '回单',
  Note: '提示: 参考运费不作为对账依据，可能会随着作业内容动态显示。',
  ViewTracking: '查看轨迹',
  ViewReceiptProof: '查看回单',
  Duration: '时效（天）',
  Settled: '已结单',
  Delivered: '已签收',
  Notracksavailable: '暂无轨迹',
  Noreceiptreturnedyet: '暂无回单',
  Nodataavailable: '暂无数据',
  Subscribetothetopic: '订阅主题',
  Subscribetotheemail: '订阅邮箱',
  Subscribetonotifications: '订阅通知',
  AuditStatus: '审核状态',
  Approved: '已通过',
  Rejected: '已拒绝',
  Pendingreview: '待审核',
  SubscriptTips3: '您订阅后会有管理员审核，审核通过后，您的订阅通知即刻生效！',
  Follow: '关注',
  Unfollow: '取关',
  Instructions1: '说明1、以上数据为截止到您当前查询时间前一天的订单情况。',
  Instructions2: '2、参考运费不作为对账依据，可能会随着作业进度有所变动。',
  Instructions3: '3、若您对此订单有疑问请发送邮件至mwarteam@mwclg.com,或致电: 021-80229869、021-80229861。',
  Recipientemailaddress: '接收邮箱',
  Emailaddress: '请输入邮箱地址',
  Yourname: '请输入您的姓名',
  Yourposition: '请输入您所在的岗位',
  Yourcontactnumber: '请输入您的联系电话',
  AddRecipientEmailAddress: '添加接收邮箱',
  PreviousStep: '上一步',
  Confirm: '确认',
  AWBNo: '运单号',
  Loading: '装',
  Unloading: '卸',
  loadingStatus: '加载中',
  month: '月度',
  startDate: '开始日期',
  endDate: '结束日期',
  view: '查看',
  download: '下载',
  dontPreview: '当前文件不支持预览',
  yourSubscript: '您的订阅',
  formayError: '邮箱格式不正确',
  delete: '删除',
  advise: '请填写您的宝贵建议',
  adviseTips: '请您具体描述其他需要订阅的场景，如您方便请留下联系方式，以便进一步沟通。',
  nothingYouWant: '没有您想要的,',
  clickFeedback: '点我反馈!',
  send: '发送',
  emailConfirm: '邮箱确认',
  ListenAdvice: '倾听您的建议',
  notUserInfo: '无法获取用户信息,请尝试重新登录',
  ruleEmail: '请输入正确的邮箱地址',
  ruleName: '订阅人姓名不能为空',
  ruleRole: '订阅人岗位不能为空',
  ruleTel: '订阅人联系方式不能为空',
  feedbackSuccess: '反馈成功！',
  ruleNodeType: '请选择要订阅的节点类型',
  hint: '提示',
  SubscribeSuccessfully: '订阅成功!',
  description: '您可以前往历史订阅中查看订阅结果',
  notLogisticsSchedule: '暂无物流进度！',
  monthNotData: '当前月份暂无数据，请换其他月份重试',
  Distribution: '国内配送',
  Trucking: '集卡运输',
  orderConfirmed: '已接单',
  orderView: '订单查看',
  subjectNotice: '以下是您定制的主题通知。',
  yourEmail: '您的邮箱：',
  unSubsribeTips: '提示：您可以勾选您要退订的主题，然后点击提交，完成退订操作。',
  unSubsribeSubmit: '提交',
  unsubscribeCenter: '退订中心',
  unsubscribeSuccess: '操作成功！',
  notUnsubscribeNode: '未选择退订节点',
  doodsAddress: '货物当前到达：',
  yourRefNo: '订单号'
}

export const DomesticTransportationEn = {
  // 英文
  DataStatistics: 'Dashboard',
  OrderInquiry: 'Tracking',
  SubscriptionCenter: 'Subscription',
  SubscribeNow: 'Create',
  PastSubscriptions: 'My Subscription',
  FeedBack: "Didn't find what you want? Click here to feedback!",
  NextStep: 'Next Step',
  SubscriptTips: 'After order creation, an email notification will be sent to you for this node',
  OrderStatus: 'Order Status',
  SubscriptTips2: 'Upon selecting a subscription, the system will send weekly order data via email',
  RegularReports: 'Regular Reports',
  MonthlySummary: 'Monthly Summary',
  Last7Days: 'Last 7 Days',
  LastMonth: 'Last Month',
  CustomInput: 'Custom Input',
  RouteFiltering: 'Route Filtering',
  All: 'All',
  TotalOrderVolume: 'Total Order Volume',
  AwaitingPickup: 'Awaiting Pickup',
  PickedUp: 'Picked Up',
  InTransit: 'In Transit',
  OutforDelivery: 'Out for Delivery',
  Signedfor: 'Delivered',
  PickupDelayed: 'Pickup Delayed',
  DeliveryDelayed: 'Delivery Delayed',
  PickupOntimeRate: 'Pickup On-time Rate',
  DeliveryOntimeRate: 'Delivery On-time Rate',
  MonthlyMileageStatistics: 'Monthly Mileage Statistics',
  MonthlyVehicleTripsCount: 'Monthly Vehicle Trips Count',
  Mileage: 'Mileage (km)',
  TotalNumberofTrips: 'Total Number of Trips',
  echartsTips: 'You can drag the bar chart left and right to view more routes',
  statement: 'Disclaimer:  The relevant information displayed on this page is for your reference only. The final information is subject to written confirmation by both parties.',
  OrderNo: 'Your Ref No.',
  Placeholder: 'Please input',
  OrderPlacementPeriod: 'Booking Date',
  Query: 'Search',
  Reset: 'Reset',
  Export: 'Export',
  DetailsView: 'Details View',
  SerialNo: 'Serial No.',
  WaybillNo: 'MW No.',
  ReferenceFreightCost: 'Reference Freight Cost',
  WaybillStatus: 'Status',
  TransportationMode: 'Transportation Mode',
  OrderDate: 'Order Date',
  Product: 'Product',
  TotalWeight: 'Total Weight (KG)',
  LoadingAddress: 'Loading Address',
  UnloadingAddress: 'Unloading Address',
  Actions: 'Actions',
  Tracking: 'Tracking',
  ReceiptProof: 'POD',
  Note: 'Note: Reference freight cost is not a basis for reconciliation and may dynamically change according to operational details.',
  ViewTracking: 'View Tracking',
  ViewReceiptProof: 'View Receipt Proof',
  Duration: 'Duration (Days)',
  Settled: 'Settled',
  Delivered: 'Delivered',
  Notracksavailable: 'No tracks available',
  Noreceiptreturnedyet: 'No receipt returned yet',
  Nodataavailable: 'No data available',
  Subscribetothetopic: 'Subscribe to the topic',
  Subscribetotheemail: 'Subscribe to the email',
  Subscribetonotifications: 'Notifications',
  AuditStatus: 'Audit status',
  Approved: 'Approved',
  Rejected: 'Rejected',
  Pendingreview: 'Pending review',
  SubscriptTips3: "After you subscribe, an administrator will review your subscription. Once it's approved, your subscription notifications will take effect immediately!",
  Follow: 'Follow',
  Unfollow: 'Unfollow',
  Instructions1: 'Instructions 1.The above data reflects order status as of the day prior to your current query time.',
  Instructions2: '2.The indicated freight charges are for reference only and do not serve as the basis for reconciliation; they may vary depending on the progress of operations.',
  Instructions3: '3.Should you have any queries regarding this order, please email us at mwarteam@mwclg.com or call us at 021-80229869 or 021-80229861.',
  Recipientemailaddress: 'Recipient infomation',
  Emailaddress: 'Email address',
  Yourname: 'Your name',
  Yourposition: 'Your position',
  Yourcontactnumber: 'Your contact number',
  AddRecipientEmailAddress: 'Add recipient infomation',
  PreviousStep: 'Previous step',
  Confirm: 'Confirm',
  AWBNo: 'AWB No.',
  Loading: 'Loading',
  Unloading: 'Unloading',
  loadingStatus: 'Loading',
  month: 'Month',
  startDate: 'Start Date',
  endDate: 'End Date',
  view: 'View',
  download: 'Download',
  dontPreview: 'The current file does not support preview',
  yourSubscript: 'Subscription content',
  formayError: 'Format error',
  delete: 'Delete',
  advise: 'Please fill in your valuable suggestions',
  adviseTips: 'Please specify other scenarios that require subscription. If it is convenient for you, please leave your contact information for further communication.',
  nothingYouWant: 'Nothing you want，',
  clickFeedback: 'Click here for feedback!',
  send: 'Send',
  emailConfirm: 'Confirmation',
  ListenAdvice: 'Listen to your suggestions',
  notUserInfo: 'Unable to get user information, please try to log in again',
  ruleEmail: 'Please enter the correct email address',
  ruleName: 'The subscriber name cannot be empty',
  ruleRole: 'The subscriber position cannot be empty',
  ruleTel: 'The subscriber contact information cannot be empty',
  feedbackSuccess: 'Feedback success!',
  ruleNodeType: 'Select the type of node to subscribe to',
  hint: 'Hint',
  SubscribeSuccessfully: 'Subscribe successfully!',
  description: 'You can view subscription results by heading to Subscription History',
  notLogisticsSchedule: 'There is no logistics progress',
  monthNotData: 'No data is available in the current month. Please try another month',
  Distribution: 'Distribution Services',
  Trucking: 'Container Trucking',
  orderConfirmed: 'Picked Up',
  orderView: 'View Order',
  subjectNotice: 'Here is the notification for your customized theme.',
  yourEmail: 'Your Email:',
  unSubsribeTips: 'Tip: You can check the themes you want to unsubscribe from, and then click submit to complete the unsubscription.',
  unSubsribeSubmit: 'Submit',
  unsubscribeCenter: 'UNSUBSCRIBE CENTER',
  unsubscribeSuccess: 'Operation successful！',
  notUnsubscribeNode: 'Unsubscription node not selected',
  doodsAddress: 'The goods are currently here: ',
  yourRefNo: 'Your Ref No.'
}
